import { $, $$ } from '../helpers/selectors';
import { tns } from 'NM/tiny-slider/src/tiny-slider';

const SELECTOR = '.inline-gallery';
const inlineGalleryClass = '.js-inline-gallery';
const inlineGalleryPageClass = '.inline-gallery__page';
const inlineGalleryNextClass = '.inline-gallery__next';
const inlineGalleryPrevClass = '.inline-gallery__prev';
class InlineGallery {
  constructor() {
    if (! $(SELECTOR)) {
      return false;
    }

    const inlineGallerySection = $$(SELECTOR);

    inlineGallerySection.forEach(section => {
      let windowResize = null;
      const inlineGallerySliderWrap = $(inlineGalleryClass, section);
      const inlineGalleryPage = $(inlineGalleryPageClass, section);
      const inlineGalleryArrows = $('.tns-controls', section);
      const inlineGalleryNext = $(inlineGalleryNextClass);
      const inlineGalleryPrev = $(inlineGalleryPrevClass);
      const inlineGalleryTablist = $$('.inline-gallery__tablist .sr-only', section);

      const inlineGallerySlider = tns({
        container: inlineGallerySliderWrap,
        items: 1,
        slideBy: 'page',
        autoplay: true,
        center: false,
        loop: true,
        controls: true,
        controlsPosition: 'bottom',
				controlsText: ["<span class=\"control-icon prev-icon\"></span>","<span class=\"control-icon next-icon\"></span>"],
        nav: true,
        navPosition: 'bottom',
        mouseDrag: true,
        autoHeight: true,
        gutter: 20,
        preventScrollOnTouch: 'force',
				speed: 800,
      });
    });
  }
}

export default InlineGallery;
